import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "h-full flex justify-center items-center"
}
const _hoisted_2 = {
  key: 1,
  class: "w-full h-full flex justify-center items-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingPanel = _resolveComponent("LoadingPanel")!
  const _component_VueApexCharts = _resolveComponent("VueApexCharts")!

  return (_ctx.dashboardModalStatePresenter.isAddingDashboardUser.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_LoadingPanel)
      ]))
    : (!_ctx.submissionStatusPresenter.hasData.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t('message.noData')), 1))
      : (_openBlock(), _createBlock(_component_VueApexCharts, {
          key: 2,
          height: "100%",
          options: _ctx.submissionStatusPresenter.chartOptions.value,
          series: _ctx.submissionStatusPresenter.chartSeries.value,
          type: "bar"
        }, null, 8, ["options", "series"]))
}